import React from 'react';
import { LanguageProvider } from './LanguageContext';
import { Header } from './components/Header';
import { Hero } from './components/Hero';
import { PainPoints } from './components/PainPoints';
import { Program } from './components/Program';
import { HowItWorks } from './components/HowItWorks';
import { Testimonial } from './components/Testimonial';
import { Faq } from './components/Faq';
import { Booking } from './components/Booking';
import { Footer } from './components/Footer';
import { Seo } from './components/Seo';
export function App() {
  return <LanguageProvider data-id="element-0">
      <Seo data-id="element-1" />
      <div className="min-h-screen bg-white font-sans text-slate-900 selection:bg-indigo-200 selection:text-indigo-900" data-id="element-2">
        <Header data-id="element-3" />
        <main data-id="element-4">
          <Hero data-id="element-5" />
          <PainPoints data-id="element-6" />
          <Program data-id="element-7" />
          <HowItWorks data-id="element-8" />
          <Testimonial data-id="element-9" />
          <Faq data-id="element-10" />
          <Booking data-id="element-11" />
        </main>
        <Footer data-id="element-12" />
      </div>
    </LanguageProvider>;
}